var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagneticAnnotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Magnetic selection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Magnetic-selection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.995000, 2.995000)",
    stroke: "#BABABA",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 15.1525604,
    y1: 13.35081,
    x2: 11.8391804,
    y2: 10.0364296,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.97357042,
    y1: 6.17081958,
    x2: 4.65919,
    y2: 2.85743958,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75389542,0.324384583 L10.505625,2.07611417 C10.9368635,2.50774241 10.9368635,3.20713676 10.505625,3.638765 L5.487535,8.65585458 C4.41981785,9.72359699 4.41981785,11.4547226 5.487535,12.522465 C6.55527738,13.5901821 8.28640301,13.5901821 9.35414542,12.522465 L14.371235,7.504375 C14.8028633,7.07313649 15.5022576,7.07313649 15.9338858,7.504375 L17.6856154,9.25610458 C17.8936381,9.46269483 18.0106252,9.74375249 18.0106252,10.0369298 C18.0106252,10.3301071 17.8936381,10.6111648 17.6856154,10.817755 L12.6675254,15.835845 C9.76959655,18.7328702 5.07208391,18.7328702 2.174155,15.835845 C-0.722870151,12.9379161 -0.722870151,8.24040345 2.174155,5.34247458 L7.192245,0.324384583 C7.39883524,0.116361933 7.6798929,-0.000625150988 7.97307021,-0.000625150988 C8.26624751,-0.000625150988 8.54730517,0.116361933 8.75389542,0.324384583 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "-0.005 -0.005 24.005 -0.005 24.005 24.005 -0.005 24.005"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagneticAnnotation);
export default __webpack_public_path__ + "static/media/MagneticAnnotation.eaf313605be789d4cb57a34646bc03d2.svg";
export { ForwardRef as ReactComponent };